import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { AppSidebar } from "@/components/layout/AppSidebar";
import {
  MobilePageHeader,
  PageHeader,
} from "@/components/layout/PageHeader";
import { SidebarLayout } from "@/components/catalyst/sidebar-layout";
import { useWebSocket } from "@/hooks/useWebSocket";

const SIDEBAR_KEY = "xapsync-sidebar-collapsed";

function initiallyCollapsed() {
  if (typeof window === "undefined") return false;

  const saved = window.localStorage.getItem(SIDEBAR_KEY);
  if (saved !== null) return saved === "true";

  return window.matchMedia("(max-width: 1279px)").matches;
}

export function AppLayout() {
  useWebSocket();

  const location = useLocation();
  const [collapsed, setCollapsed] = useState(initiallyCollapsed);
  const isDeviceDetail = /^\/devices\/[^/]+\/?$/.test(location.pathname);
  const isTracking = location.pathname.startsWith("/tracking");
  const previousPath = useRef(location.pathname);

  useEffect(() => {
    const enteredTracking = (
      isTracking
      && !previousPath.current.startsWith("/tracking")
    );
    if (enteredTracking) {
      setCollapsed(true);
    }
    previousPath.current = location.pathname;
  }, [isTracking, location.pathname]);

  function toggleCollapsed() {
    setCollapsed((current) => {
      const next = !current;
      window.localStorage.setItem(SIDEBAR_KEY, String(next));
      return next;
    });
  }

  return (
    <SidebarLayout
      collapsed={collapsed}
      wideContent={isDeviceDetail || isTracking}
      sidebar={
        <AppSidebar collapsed={collapsed} onToggleCollapsed={toggleCollapsed} />
      }
      mobileSidebar={<AppSidebar collapsed={false} />}
      navbar={<MobilePageHeader />}
    >
      {!isDeviceDetail && <PageHeader />}
      <Outlet />
    </SidebarLayout>
  );
}
